<template>
  <v-dialog v-model="dialog" persistent max-width="480px">
    <v-card class="brand-dialog-card">
      <div class="dialog-header">
        <div>
          <div class="dialog-title">Edit Brand</div>
          <div class="dialog-subtitle">Update product brand name.</div>
        </div>

        <v-btn icon small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="dialog-body mt-4">
        <div class="form-section">
          <div class="section-title">Brand Info</div>

          <div class="field-label mt-3">Name</div>
          <v-text-field
            outlined
            dense
            :hide-details="nameErrors.length === 0"
            :error-messages="nameErrors"
            v-model="Brand.name"
            label="Name"
            @keyup.enter="submit"
          />
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="dialog-actions">
        <v-spacer />
        <v-btn color="primary" text @click="close">Close</v-btn>
        <v-btn
          color="primary"
          depressed
          rounded
          dark
          :loading="loading"
          @click="submit"
        >
          Update Brand
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BrandService from "../service.js";
import _ from "lodash";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "update-brand",

  props: {
    editDialog: {
      default: false,
    },
    editBrand: {
      type: Object,
      default: null,
    },
  },

  mixins: [validationMixin],

  data() {
    return {
      loading: false,
      dialog: false,
      Brand: this.getEmptyBrand(),
    };
  },

  validations: {
    Brand: {
      name: {
        required,
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];

      if (!this.$v.Brand.name.$dirty) {
        return errors;
      }

      if (!this.$v.Brand.name.required) {
        errors.push(this.$t("validations.fieldIsRequired"));
      }

      return errors;
    },
  },

  watch: {
    editDialog(val) {
      this.dialog = val;

      if (val) {
        this.Brand = this.editBrand
          ? _.cloneDeep(this.editBrand)
          : this.getEmptyBrand();

        this.$v.$reset();
      }
    },
  },

  methods: {
    getEmptyBrand() {
      return {
        id: null,
        name: null,
      };
    },

    formatName() {
      if (!this.Brand.name) {
        return;
      }

      this.Brand.name =
        this.Brand.name.charAt(0).toUpperCase() + this.Brand.name.slice(1);
    },

    close() {
      this.empty();
      this.dialog = false;
      this.$emit("close");
    },

    empty() {
      this.Brand = this.getEmptyBrand();
      this.$v.$reset();
    },

    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
        return;
      }

      if (!this.Brand.id) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Brand ID is missing",
          });
        return;
      }

      this.loading = true;
      this.formatName();

      return BrandService.update(this.Brand.id, this.Brand)
        .then((result) => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Brand is updated",
              });

            this.$emit("submit");
            this.close();
          }
        })
        .catch((err) => {
          const message =
            err && err.data && err.data.message
              ? err.data.message
              : "Unable to update brand";

          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: message,
            });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.brand-dialog-card {
  border-radius: 20px;
  overflow: hidden;
}

.dialog-header {
  padding: 18px 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.dialog-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
}

.dialog-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.dialog-body {
  padding: 16px;
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 14px;
}

.section-title {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.field-label {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 6px;
}

.dialog-actions {
  padding: 12px 16px;
}
</style>